export default {
  c1: 'Room',
  c2: 'Clothes',
  c3: 'Figure',
  c4: 'Save',
  c5: 'All categories',
  c6: 'Wallpaper',
  c7: 'Floor',
  c8: 'Window',
  c9: 'Ornaments',
  c10: 'Sports Equipment',
  c11: 'Plants',
  c12: 'TV',
  c13: 'Sofa',
  c14: 'Coffee Table',
  c15: 'Floor Lamp',
  c16: 'Mirror',
  c17: 'Activity exclusive',
  c18: 'Saved',
  c19: 'Please try again',
  c20: 'Decoration not saved',
  c21: 'The current decoration content has not been saved and will not be retained after leaving. Do you want to save the current content?',
  c22: 'Leave',
  c23: 'Save',
  c24: 'Activity exclusive',
  c25: 'Introduction',
  c26: 'Access',
  c27: 'Go',
  c28: 'Home',
  c29: 'Saved',
  c30: 'Please try again',
  c31: 'skip',
  c32: 'Click to change to the outfit you like',
  c33: 'Click to switch Figure /Clothes /Decoration',
  c34: 'Next',
  c35: 'I got it',
  c36: 'Click to select the category you want',
  c37: 'Click to change to the style/item you like',
  c38: 'Don\'t forget to click ',
  c39:'save',
  c40:' when you\'re done decorating',
  c41:'Click to select your basic image',
  c42:'Suit',
  c43:'Image',
  c44:'Saving, please wait...',
  c45:'Landscape',
  c46:'Christmas Decorations',
  c47:'Christmas Hangings',
  c48:'Personalization',
  c49:'Please upgarde to change your new image',
  c50:'Figure',
  c51:'Theme',
  c52:'Potrait Pendant',
  c53:'Room',
  c50_1:'Get my meta avatar',
  c51_1:'Choose my themes',
  c52_1:'Pick my decorations',
  c53_1:'Enter my meta place',
  c54:'Prompt',
  c55:'You will enter MyLink Metaverse, are you sure you want to continue?',
  c56:'Cancel',
  c57:'OK',
  c58:'https://mylink.oss-accelerate.aliyuncs.com/myHomeIcon/smallIcon1EN.png'
}
